import React from 'react';
import './DecorativeShapes.css';

const DecorativeShapes = () => {
  return (
    <div className="decorative-shapes">
      {/* Floating Solar Panel Icons */}
      <div className="floating-shape shape-1">
        <i className="fas fa-solar-panel"></i>
      </div>
      <div className="floating-shape shape-2">
        <i className="fas fa-leaf"></i>
      </div>
      <div className="floating-shape shape-3">
        <i className="fas fa-bolt"></i>
      </div>
      <div className="floating-shape shape-4">
        <i className="fas fa-sun"></i>
      </div>
      <div className="floating-shape shape-5">
        <i className="fas fa-home"></i>
      </div>
      <div className="floating-shape shape-6">
        <i className="fas fa-recycle"></i>
      </div>

      {/* Geometric Shapes */}
      <div className="geometric-shape geo-1"></div>
      <div className="geometric-shape geo-2"></div>
      <div className="geometric-shape geo-3"></div>
      <div className="geometric-shape geo-4"></div>
      <div className="geometric-shape geo-5"></div>
      <div className="geometric-shape geo-6"></div>

      {/* SVG Wave Curves */}
      <div className="curve-shape curve-top">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z" className="curve-fill"></path>
        </svg>
      </div>

      <div className="curve-shape curve-bottom">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z" className="curve-fill"></path>
        </svg>
      </div>

      {/* Gradient Orbs */}
      <div className="gradient-orb orb-1"></div>
      <div className="gradient-orb orb-2"></div>
      <div className="gradient-orb orb-3"></div>
      <div className="gradient-orb orb-4"></div>

      {/* Energy Lines */}
      <div className="energy-line line-1"></div>
      <div className="energy-line line-2"></div>
      <div className="energy-line line-3"></div>
      <div className="energy-line line-4"></div>
    </div>
  );
};

export default DecorativeShapes;